const HANDOFF_MARKER = 'externalBrowser';

export function isAndroidMetaBrowser(userAgent: string): boolean {
  return /Android/i.test(userAgent)
    && /(?:FB_IAB\/|FBAN\/|FBAV\/|\bMetaIAB\b)/i.test(userAgent);
}

export function isMetaSharePage(page: URL, userAgent: string): boolean {
  return /^\/share\/[^/]+\/?$/.test(page.pathname) && isAndroidMetaBrowser(userAgent);
}

export function externalBrowserIntent(shareUrl: URL): string {
  const destination = new URL(shareUrl.href);
  destination.searchParams.set(HANDOFF_MARKER, '1');
  destination.hash = '';
  return `intent://${destination.host}${destination.pathname}${destination.search}#Intent;scheme=${destination.protocol.slice(0, -1)};action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;S.browser_fallback_url=${encodeURIComponent(destination.href)};end`;
}

export function requestShareBrowserHandoff(): void {
  const page = new URL(window.location.href);
  if (!isMetaSharePage(page, window.navigator.userAgent)
    || page.searchParams.has(HANDOFF_MARKER)) return;

  // Record the attempt before navigation; fallback URLs also carry the marker.
  const key = `cr.shareBrowserHandoff:${page.pathname}`;
  try {
    if (window.sessionStorage.getItem(key)) return;
    window.sessionStorage.setItem(key, '1');
  } catch {
    // Keep loop protection even when the embedded browser blocks storage.
  }
  page.searchParams.set(HANDOFF_MARKER, '1');
  window.history.replaceState(window.history.state, '', page.href);
  try {
    window.location.assign(externalBrowserIntent(page));
  } catch {
    // The ordinary share viewer and manual link remain available.
  }
}
